import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {EditPermissions} from '../../../../../../../shared/models';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {getEditTypes} from '../../../delegatorUtils';
import {isValidGroupingSeparator, required} from '../../../../../../../shared/utils';


export const NODE_TYPE = 'decimalFormat';
export interface DecimalFormatFormType {
    actionParams: any;
    actionResults: any;
}


export class DecimalFormatNode {
    action: any = {};

    constructor() {
        this.action = {
            actionType: NODE_TYPE
        };
    }

    static toForm(stepData: { [index: string]: any }): DecimalFormatFormType {
        return {
            actionParams: this.actionParamsForm(stepData),
            actionResults: this.actionResultsForm(stepData)
        };
    }

    static actionParamsForm(stepData: { [index: string]: any }): {} {
        const action = stepData.action;
        return {
            name: action?.name ? action.name : '',
            description: action?.description ? action.description : '',
            variableName: action?.actionParams?.variableName ? action?.actionParams?.variableName : '',
            pattern: action?.actionParams?.pattern ? action?.actionParams?.pattern : '',
            groupSeparator: action?.actionParams?.groupSeparator ? action?.actionParams?.groupSeparator : 'none'
        };
    }

    static actionResultsForm(stepData: { [index: string]: any }): {} {
        const action = stepData.action;
        return {
            success: action?.result && action?.result.yes ? action?.result.yes : newStepValue,
            error: action?.result && action?.result.no ? action?.result.no : newStepValue
        };
    }

    static getActionParamsTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);

        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }),
            description: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, required('Description')),
            variableName: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, required('Variable Name')),
            pattern: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, required('Pattern')),
            groupSeparator: new UntypedFormControl({
                value: 'none',
                disabled: !editFlows
            }, isValidGroupingSeparator('Group Separator'))
        });
    }

    static getActionResultTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);

        return new UntypedFormGroup({
            success: new UntypedFormControl({
                value: newStepValue,
                disabled: !editFlows
            }),
            error: new UntypedFormControl({
                value: newStepValue,
                disabled: !editFlows
            }),
        });
    }

    get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

    addActionParams(params: any) {
        const { name, description, pattern, variableName, groupSeparator } = params;

        const actionParams = {
            pattern,
            variableName
        };

        if (groupSeparator !== 'none') {
            actionParams['groupSeparator'] = groupSeparator;
        }

        this.action = {
            ...this.action,
            name,
            description,
            actionParams: actionParams
        };
    }

    addActionResult(results: any) {
        this.action = {
            ...this.action,
            result: {
                'yes': results.success,
                'no': results.error,
            }
        };
    }

}
